import { K3Extensions } from '@k3/core';
import { DeepRequired } from '../types/DeepRequired';
import { Stack } from '@mui/material';
import { RestartButton } from './RestartButton';

export const SceneButtons: DeepRequired<K3Extensions>['app']['sceneButtons']['root'] =
  (Wrapped) => (props) => {
    return (
      <Stack direction="row" spacing={1}>
        <RestartButton />
      </Stack>
    );
  };
